import Utils from "../utils/utils";
/**
 * 购买信息map
 */
const urlMap = new Map([
  [
    "ar",
    new Map([
      ["homepage", "https://ar.hitpaw.com/"],
      ["editorPage", "https://online.hitpaw.com/ar/index.html"],
    ]),
  ],
  [
    "br",
    new Map([
      ["homepage", "https://www.hitpaw.com.br/"],
      ["editorPage", "https://online.hitpaw.com.br/index.html"],
    ]),
  ],
  [
    "cn",
    new Map([
      ["homepage", "https://www.hitpaw.com/"],
      ["editorPage", "https://online.hitpaw.com/index.html"],
    ]),
  ],
  [
    "de",
    new Map([
      ["homepage", "https://www.hitpaw.de/"],
      ["editorPage", "https://online.hitpaw.de/index.html"],
    ]),
  ],
  [
    "es",
    new Map([
      ["homepage", "https://www.hitpaw.es/"],
      ["editorPage", "https://online.hitpaw.es/index.html"],
    ]),
  ],
  [
    "en",
    new Map([
      ["homepage", "https://www.hitpaw.com/"],
      ["editorPage", "https://online.hitpaw.com/index.html"],
    ]),
  ],
  [
    "fr",
    new Map([
      ["homepage", "https://www.hitpaw.fr/"],
      ["editorPage", "https://online.hitpaw.fr/index.html"],
    ]),
  ],
  [
    "id",
    new Map([
      ["homepage", "https://www.hitpaw.id/"],
      ["editorPage", "https://online.hitpaw.id/index.html"],
    ]),
  ],
  [
    "in",
    new Map([
      ["homepage", "https://www.hitpaw.in/"],
      ["editorPage", "https://online.hitpaw.in/index.html"],
    ]),
  ],
  [
    "it",
    new Map([
      ["homepage", "https://www.hitpaw.it/"],
      ["editorPage", "https://online.hitpaw.it/index.html"],
    ]),
  ],
  [
    "jp",
    new Map([
      ["homepage", "https://www.hitpaw.jp/"],
      ["editorPage", "https://online.hitpaw.jp/index.html"],
    ]),
  ],
  [
    "kr",
    new Map([
      ["homepage", "https://www.hitpaw.kr/"],
      ["editorPage", "https://online.hitpaw.kr/index.html"],
    ]),
  ],
  [
    "nl",
    new Map([
      ["homepage", "https://www.hitpaw.nl/"],
      ["editorPage", "https://online.hitpaw.nl/index.html"],
    ]),
  ],
  [
    "ru",
    new Map([
      ["homepage", "https://www.hitpaw.ru/"],
      ["editorPage", "https://online.hitpaw.ru/index.html"],
    ]),
  ],
  [
    "tr",
    new Map([
      ["homepage", "https://tr.hitpaw.com/"],
      ["editorPage", "https://online.hitpaw.com/tr/index.html"],
    ]),
  ],
  [
    "tw",
    new Map([
      ["homepage", "https://www.hitpaw.tw/"],
      ["editorPage", "https://online.hitpaw.tw/index.html"],
    ]),
  ],
]);

export default urlMap.get(Utils.getLanguage());
